export function merchantJsonLd(merchant: Record<string, unknown>) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: merchant.merchant_name,
    description: merchant.merchant_description,
    logo: merchant.merchant_image_url_logo,
  };
}

export function personaJsonLd(opts: {
  name: string;
  handle: string;
  description?: string;
  image?: string;
  url: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    mainEntity: {
      "@type": "Person",
      name: opts.name,
      alternateName: opts.handle,
      ...(opts.description ? { description: opts.description } : {}),
      ...(opts.image ? { image: opts.image } : {}),
      url: opts.url,
    },
  };
}
